import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CourseCard from '../common/CourseCard';

const CoursesPreview = () => {
  const { t } = useTranslation();

  const featuredCourses = [
    {
      id: 1,
      title: t('courses.crash_course_archicad'),
      description: t('courses.archicad_course_description'),
      category: t('categories.architecture'),
      duration: t('duration.5_sessions'),
      language: t('languages.arabic'),
      instructor: "Mohammad Hamad",
    },
    
    {
      id: 2,
      title: t('courses.job_application_course'),
      description: t('courses.job_application_description'),
      category: t('categories.general'),
      duration: t('duration.3_hours'),
      language: t('languages.arabic_german'),
      instructor: t('Dipl.-Ing. Taher Doufesh'),
      link: t('/courses/job-application')
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold">
            {t('home.coursesTitle')}
          </h2>
          <Link 
            to="/courses" 
            className="text-primary-600 hover:text-primary-800 font-medium"
          >
            {t('common.viewAll')} →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {featuredCourses.map(course => (
            <CourseCard key={course.id} {...course} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesPreview;